// Sentry initialization. Needs to be imported first
import "./instrument";
import React from "react";
import { createRoot } from "react-dom/client";
import "semantic-ui-css/semantic.min.css";
import App from "./containers/App";
import Keycloak from "keycloak-js";
import axios from "axios";
import { Provider } from "react-redux";
import { createOrUpdateUser } from "./lib/userServices";
import i18n from "./i18n";
import moment from "moment";
import setupStore from "./setupStore";

//window.localStorage.setItem('debug', '* -engine* -socket* -RIE* *WARN* *ERROR*');

const store = setupStore();

const kc = new Keycloak({
  url: process.env.REACT_APP_KC_ISSUER_URL,
  realm: process.env.REACT_APP_KC_REALM,
  clientId: process.env.REACT_APP_KC_CLIENT
});


kc.init({ onLoad: "check-sso" }).success((authenticated) => {
  if (authenticated) {
    let normalizedBirthday = kc.tokenParsed.birthday;
    if (normalizedBirthday) {
      if (typeof normalizedBirthday === 'string' && !normalizedBirthday.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const dateObj = new Date(normalizedBirthday);
        if (!isNaN(dateObj.getTime())) {
          normalizedBirthday = dateObj.toISOString().split('T')[0];
        }
      }
    }
    
    createOrUpdateUser({
      user_id: kc.tokenParsed.sub,
      username: kc.tokenParsed.preferred_username,
      first_name: kc.tokenParsed.given_name,
      last_name: kc.tokenParsed.family_name,
      learning_institution: kc.tokenParsed.learning_institution,
      dob: normalizedBirthday,
      phone: kc.tokenParsed.phone,
      province: kc.tokenParsed.province,
      timezone: kc.tokenParsed.timezone,
      locale: kc.tokenParsed.locale,
    });
    //check if users language is in localStorage and if not check keycloak lang
    const lang = localStorage.getItem("lang") || kc.tokenParsed.locale || "en";
    localStorage.setItem("lang", lang);
    i18n.changeLanguage(lang);
    moment.locale(lang);

    setInterval(() => {
      kc.updateToken(10).error(() => kc.logout());
    }, 10000);

    const container = document.getElementById("root");
    const root = createRoot(container);
    root.render(
      <Provider store={store}>
        <App keycloak={kc} />
      </Provider>
    );
    } else {
      // Check locale from URL first
      const params = new URLSearchParams(window.location.search);
      const localeFromUrl = params.get("locale");
      const lang =
        localeFromUrl ||
        localStorage.getItem("lang") ||
        "en";

      // Persist selected language
      localStorage.setItem("lang", lang);
      kc.login({
        locale: lang,
      });
    }
});

axios.interceptors.request.use(
  (config) => {
    let token = kc.token;
    if (token) {
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        },
      };
    }
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);
